import { T } from 'ramda';
import { assign } from 'xstate';
import { AppBarEvent } from '../../../events';
import { AppBarMachineContext } from '../../../machineContext';

export const name = 'setOpen';

export const fn = assign<AppBarMachineContext, AppBarEvent>({
  openAction: () => 0,
  immediate: T,
});

export const action = {
  [name]: fn,
};

export default action;
